export default __webpack_public_path__ + "static/media/infinity.439329dd.svg";